import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { VTableRowStatus } from "@app/directives/_layout/v-table/_enums/VTableRowStatus.enum";
import { IVehicle } from "@app/interfaces/IVehicle";
import { IAccount } from "@app/services/account.service";
import { DataCacheService } from "@app/services/caching/data-cache.service";
import { Observable } from "rxjs";
import { AccountSubscriptionType } from "../_enums/AccountSubscriptionType";
import { IAccountSubscription } from "../_models/IAccountSubscription";

@Injectable({
    providedIn: 'root'
})
export class CustomerSubscriptionService {
    private subscriptionsCacheName: string = "customerSubscriptionsCache";

    constructor(
        private readonly http: HttpClient,
        private readonly dataCacheService: DataCacheService
    ) {
    }

    getSubscriptions(invalidateCache = false): Observable<IAccountSubscription[]> {
        return this.dataCacheService.getOrRequest(this.subscriptionsCacheName, () => this.getSubscriptionsFromDb(), { invalidateCache, keyName: "AccountId" });
    }

    getSubscriptionsFromDb(): Observable<IAccountSubscription[]> {
        return this.http.get<IAccountSubscription[]>("/api/account/subscriptions/");
    }

    getSubscriptionsForAccount(accountId: number): Observable<IAccountSubscription[]> {
        const subscriptions = this.dataCacheService.getSingleValue(accountId, this.subscriptionsCacheName);

        if (subscriptions?.length) {
            return subscriptions;
        }

        return this.http.get<IAccountSubscription[]>("/api/account/subscriptions/", { params: { accountId } });
    }

    getSubscriptionCost(sub: IAccountSubscription): number {
        return sub.Amount * this.getSubscriptionCostPerUnit(sub);
    }

    //// Returns cost in £ per Unit/Vehicle in a decimal value. 0.15 = 15p, 1 = £1
    getSubscriptionCostPerUnit(sub: IAccountSubscription): number {
        switch (sub.Type) {
            case AccountSubscriptionType.EmailQuota:
                return 0.002;

            case AccountSubscriptionType.SmsQuota:
                // 3 segments per "message"
                return 0.15;

            case AccountSubscriptionType.ContextualSpeeding:
            case AccountSubscriptionType.Reefer:
            case AccountSubscriptionType.Tms:
            case AccountSubscriptionType.ReportBuilder:
                return 1;

            case AccountSubscriptionType.SSO:
                return 2;
        }

        return null;
    }

    setEndTimes(subscriptions: IAccountSubscription[], customers: IAccount[]) {
        subscriptions.forEach(s => {

            s.account = customers.find(c => c.Id == s.AccountId);

            if (!s.EndTime) {
                // Max date
                s.EndTime = new Date(8640000000000000);
            }

            s.active = s.EndTime > new Date;
            s.status = s.active ? VTableRowStatus.Success : VTableRowStatus.Info
        });
    }

    calculateSubscriptionCosts(subscriptions: IAccountSubscription[], vehicles: IVehicle[]): number {
        var totalCharge = 0;

        subscriptions.forEach(sub => {
            if (!sub.Amount) {
                sub.Amount = vehicles.filter(v => v.AccountId == sub.AccountId).length;
            }

            sub.ChargePerUnit = this.getSubscriptionCostPerUnit(sub);
            sub.TotalCharge = this.getSubscriptionCost(sub);

            if (sub.active) {
                totalCharge += sub.TotalCharge || 0;
            }
        });

        return totalCharge;
    }

    // ---
}
